import { fadeIn, fadeOut, gebi, genUID } from '@utils/toolbox';
export class SVGSpinner {
	constructor (options) {
		this.target = options.target;
		this.size = options.size || '40px';
		this.color = options.color || '#2e5a8b';
		this.speed = options.speed || '600ms';
		this.style = options.isVisible ? 'display: block;' : 'display: none;';
		this.style = this.style + (options.style || '');
		this.id = options.id || genUID();
		this.className = options.className;
		this.svg = `
<svg 
  class="${this.className}"
  id="${this.id}"
  style="${this.style}"
  width ="${this.size}"
  height ="${this.size}"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 100 100"
  preserveAspectRatio="xMidYMid">
    <path fill="none"
      class="bk"
      d="M0 0h100v100H0z"/>
    <circle cx="50"
      cy="50"
      r="43"
      stroke-dasharray="175.61502933566945 94.56193887305275"
      stroke="${this.color}"
      fill="none"
      stroke-width="14">
      <animateTransform attributeName="transform"
        type="rotate"
        values="0 50 50;180 50 50;360 50 50;"
        keyTimes="0;0.5;1"
        dur="${this.speed}"
        repeatCount="indefinite"
        begin="0s"/>
    </circle>
</svg>`;
		this.target.insertAdjacentHTML('beforeend', this.svg);
		// Can't use document.createElement (with SVGs) to get the reference so we use gebi
		this.svgElem = gebi(this.id);
	}

	show () {
		fadeIn(this.svgElem);
	}

	hide () {
		fadeOut(this.svgElem);
	}
}
